import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../../BaseController'
import { Inject } from '@odinjs/odin';
import { AvatarAPI } from '@philips-internal/oswald-ui-components';
import {ExamCollectionAliases as Alias, FragmentNames} from '../../../codegen';

@Controller({ component: Alias.MAIN_LAYOUT, fragment: FragmentNames.EXAM_COLLECTION })
export default class ExamCollectionController extends BaseController {
  
  @Inject(Alias.AVATAR_EC)
  avatarAPI!: AvatarAPI;

  @OnMount(Alias.AVATAR_EC)
  handleMountAvatar(): void {
    const desktopNotSupported = '../../../../resources/assets/desktop_not_supported.svg';
    this.avatarAPI.setImage(desktopNotSupported);
  }
}